// extracted by mini-css-extract-plugin
export default {"control":"styles_control__LolV3","controlIndicator":"styles_controlIndicator__2urcA","controlCheckbox":"styles_controlCheckbox__SROMd"};